// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.more-text {
    /*margin-top: 4px;*/
    border: none;
    background: none;
    cursor: pointer;
    /*padding: 0;*/
    font-size: 0.8em;
}`, "",{"version":3,"sources":["webpack://./src/components/MoreText/MoreText.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB","sourcesContent":[".more-text {\n    /*margin-top: 4px;*/\n    border: none;\n    background: none;\n    cursor: pointer;\n    /*padding: 0;*/\n    font-size: 0.8em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
